import logo from './logo.svg';
import './App.css';
import Loader from './utils/Loader';
import { Route, Routes } from 'react-router-dom';
import Dashboard from './layout/Dashboard';
import Signin from './Pages/Authentication/Signin';
import UnAuthorized from './Router/Unauthorised';
import Authorized from './Router/Authorised';
import UserManagement from './Pages/User/User';
import LeadManagement from './Pages/CRM/Lead';
import { Empty } from 'antd';
import ProductManagement from './Pages/Product/Product';
import OrderManagement from './Pages/Order/Order';
import AnalyticsDashboard from './Pages/Analytics/Analytics';
import OrderManagement_v1 from './Pages/Order/Order_v1';
import ProformaInvoice from './Pages/PerfomaInvoice';
import JobOrderProforma from './Pages/Receipt';
import JobDashboard from './Pages/Jobs/JobDashboard';

function App() {
  return (
    <div className="App font-printverse">
        <Routes>
        <Route path="/signin" element={<Signin />} />
        <Route path="/unauthorized" element={<UnAuthorized />} />
        <Route path="/" element={<Authorized allowedRoles={["SUDO"]} />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/user" element={<Dashboard component={<UserManagement />} />} />
        <Route path="/leads" element={<Dashboard component={<LeadManagement />} />} />
        <Route path="/analytics" element={<Dashboard component={<AnalyticsDashboard />} />} />
        <Route path="/conversions" element={<Dashboard component={<OrderManagement />} />} />
        <Route path="/conversions_v1" element={<Dashboard component={<OrderManagement_v1 />} />} />
        <Route path="/jobs" element={<Dashboard component={<JobDashboard />} />} />
        <Route path="/products" element={<Dashboard component={<ProductManagement />} />} />
        <Route path="/invoice" element={<ProformaInvoice />} />
        <Route path="/receipt" element={<JobOrderProforma />} />
        </Route>
        </Routes>
    </div>
  );
}

export default App;
